// メッセージMap
export const MessageMap = {
    "interview_title": "Web面接タイトル",
    "interview_dest": "宛先",
    "interview_others_dest": "宛先追加",
    "interview_date": "日付",
    "interview_start_time": "時間(日本時間)開始",
    "interview_time_minutes": "時間(日本時間)"
};
